import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _get from "lodash/get";
import "core-js/modules/es6.object.keys.js";
import config from '@nerdwallet/app-config';
/**
 * Provides reflected object of feature flags, meant for use with default export
 * @type {Object}
 */

export var FEATURE_FLAGS = Object.keys(_get(config, 'FEATURE_FLAGS', {})).reduce(function (acc, k) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, k, k));
}, {});
/**
 * Get an app-config driven feature flag.
 * @example
 * // given config
 * FEATURE_FLAGS:
 *   FOO: true
 * @example
 * import getFeatureFlag, { FEATURE_FLAGS } from '@nerdwallet/home-app-lib/feature-flags';
 *
 * getFeatureFlag(FEATURE_FLAGS.FOO); // true
 * @see https://www.github.com/NerdWallet/nwjs-feature-flags
 * @deprecated
 * @function
 * @param  {String} key The key
 * @return {Mixed}    The value of the flag
 */

export default (function (key) {
  return _get(config, ['FEATURE_FLAGS', key]);
});